import {ViewPersonalConfig} from "../../@type";
import {PersonalViewLocation} from "../@types";
import {ViewType} from "../../../../gd/const/views/view-type";
import {Feature} from "../../../../gd/access-control/feature-access/const";

export const MY_TIME_CONFIG : ViewPersonalConfig = {
    type            : ViewType.MY_TIME,
    // name            : 'My Time',
    name            : 'Time Tracking',
    icon            : 'i5-timesheets',
    iconSvg         : 'isvg-view-my-time',
    url             : 'my-time',
    description     : 'Track and report your time',
    defaultLocation : PersonalViewLocation.HOME,
    feature         : Feature.TIME_TRACKING
}
